<template>
    <div>
        <datum></datum>
    </div>
</template>
<script>

import datum from '@/components/datum/datum'

export default {
    data(){
        return {

        }
    },
     components: {
         datum
    },


    methods:{

    },
    mounted(){
    }
}
</script>
<style scoped lang="scss">

</style>
